import { DOCUMENT } from '@angular/common';
import {
  APP_ID,
  CSP_NONCE,
  inject,
  PLATFORM_ID,
  Provider,
  ɵSHARED_STYLES_HOST as SHARED_STYLES_HOST,
} from '@angular/core';
import { ɵSharedStylesHost as SharedStylesHost } from '@angular/platform-browser';

const MATERIAL_STYLE_PATTERN = /(?:^|[\s{;])(?:\.mat-|\.mdc-|--mdc-|\.cdk-)/;

const createLayerPattern = (layerName: string) =>
  new RegExp(`^\\s*@layer\\s+${layerName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*\\{`);

export function wrapMaterialStylesInLayer(css: string, layerName = 'material-base'): string {
  if (!css || createLayerPattern(layerName).test(css) || !MATERIAL_STYLE_PATTERN.test(css)) {
    return css;
  }

  return `@layer ${layerName}{\n${css}\n}`;
}

class MaterialLayerStylesHost extends SharedStylesHost {
  constructor(
    doc: Document,
    appId: string,
    nonce?: string | null,
    platformId?: object,
    private readonly layerName = 'material-base',
  ) {
    super(doc, appId, nonce, platformId);
  }

  override addStyles(styles: string[], urls?: string[]): void {
    super.addStyles(
      styles.map((style) => wrapMaterialStylesInLayer(style, this.layerName)),
      urls,
    );
  }

  override removeStyles(styles: string[], urls?: string[]): void {
    super.removeStyles(
      styles.map((style) => wrapMaterialStylesInLayer(style, this.layerName)),
      urls,
    );
  }
}

export function provideMaterialLayerStyles(layerName = 'material-base'): Provider {
  return {
    provide: SHARED_STYLES_HOST,
    useFactory: () =>
      new MaterialLayerStylesHost(
        inject(DOCUMENT),
        inject(APP_ID),
        inject(CSP_NONCE, { optional: true }),
        inject(PLATFORM_ID),
        layerName,
      ),
  };
}
